import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SolanaError, SOLANA_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY, SOLANA_ERROR__CODECS__INVALID_BYTE_LENGTH, SOLANA_ERROR__CODECS__OFFSET_OUT_OF_RANGE, SOLANA_ERROR__CODECS__EXPECTED_FIXED_LENGTH, SOLANA_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH, SOLANA_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH, SOLANA_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH, SOLANA_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH, SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH } from '@solana/errors'; // src/assertions.ts

function assertByteArrayIsNotEmptyForCodec(codecDescription, bytes) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (bytes.length - offset <= 0) {
    throw new SolanaError(SOLANA_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY, {
      codecDescription: codecDescription
    });
  }
}

function assertByteArrayHasEnoughBytesForCodec(codecDescription, expected, bytes) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var bytesLength = bytes.length - offset;

  if (bytesLength < expected) {
    throw new SolanaError(SOLANA_ERROR__CODECS__INVALID_BYTE_LENGTH, {
      bytesLength: bytesLength,
      codecDescription: codecDescription,
      expected: expected
    });
  }
}

function assertByteArrayOffsetIsNotOutOfRange(codecDescription, offset, bytesLength) {
  if (offset < 0 || offset > bytesLength) {
    throw new SolanaError(SOLANA_ERROR__CODECS__OFFSET_OUT_OF_RANGE, {
      bytesLength: bytesLength,
      codecDescription: codecDescription,
      offset: offset
    });
  }
} // src/bytes.ts


var mergeBytes = function mergeBytes(byteArrays) {
  var nonEmptyByteArrays = byteArrays.filter(function (arr) {
    return arr.length;
  });

  if (nonEmptyByteArrays.length === 0) {
    return byteArrays.length ? byteArrays[0] : new Uint8Array();
  }

  if (nonEmptyByteArrays.length === 1) {
    return nonEmptyByteArrays[0];
  }

  var totalLength = nonEmptyByteArrays.reduce(function (total, arr) {
    return total + arr.length;
  }, 0);
  var result = new Uint8Array(totalLength);
  var offset = 0;
  nonEmptyByteArrays.forEach(function (arr) {
    result.set(arr, offset);
    offset += arr.length;
  });
  return result;
};

var padBytes = function padBytes(bytes, length) {
  if (bytes.length >= length) return bytes;
  var paddedBytes = new Uint8Array(length).fill(0);
  paddedBytes.set(bytes);
  return paddedBytes;
};

var fixBytes = function fixBytes(bytes, length) {
  return padBytes(bytes.length <= length ? bytes : bytes.slice(0, length), length);
};

function getEncodedSize(value, encoder) {
  return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}

function createEncoder(encoder) {
  return Object.freeze(_objectSpread(_objectSpread({}, encoder), {}, {
    encode: function encode(value) {
      var bytes = new Uint8Array(getEncodedSize(value, encoder));
      encoder.write(value, bytes, 0);
      return bytes;
    }
  }));
}

function createDecoder(decoder) {
  return Object.freeze(_objectSpread(_objectSpread({}, decoder), {}, {
    decode: function decode(bytes) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return decoder.read(bytes, offset)[0];
    }
  }));
}

function createCodec(codec) {
  return Object.freeze(_objectSpread(_objectSpread({}, codec), {}, {
    decode: function decode(bytes) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return codec.read(bytes, offset)[0];
    },
    encode: function encode(value) {
      var bytes = new Uint8Array(getEncodedSize(value, codec));
      codec.write(value, bytes, 0);
      return bytes;
    }
  }));
}

function isFixedSize(codec) {
  return "fixedSize" in codec && typeof codec.fixedSize === "number";
}

function assertIsFixedSize(codec) {
  if (!isFixedSize(codec)) {
    throw new SolanaError(SOLANA_ERROR__CODECS__EXPECTED_FIXED_LENGTH);
  }
}

function isVariableSize(codec) {
  return !isFixedSize(codec);
}

function assertIsVariableSize(codec) {
  if (!isVariableSize(codec)) {
    throw new SolanaError(SOLANA_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH);
  }
}

function combineCodec(encoder, decoder) {
  if (isFixedSize(encoder) !== isFixedSize(decoder)) {
    throw new SolanaError(SOLANA_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH);
  }

  if (isFixedSize(encoder) && isFixedSize(decoder) && encoder.fixedSize !== decoder.fixedSize) {
    throw new SolanaError(SOLANA_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH, {
      decoderFixedSize: decoder.fixedSize,
      encoderFixedSize: encoder.fixedSize
    });
  }

  if (!isFixedSize(encoder) && !isFixedSize(decoder) && encoder.maxSize !== decoder.maxSize) {
    throw new SolanaError(SOLANA_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH, {
      decoderMaxSize: decoder.maxSize,
      encoderMaxSize: encoder.maxSize
    });
  }

  return _objectSpread(_objectSpread(_objectSpread({}, decoder), encoder), {}, {
    decode: decoder.decode,
    encode: encoder.encode,
    read: decoder.read,
    write: encoder.write
  });
} // src/fix-codec.ts


function fixEncoder(encoder, fixedBytes) {
  return createEncoder({
    fixedSize: fixedBytes,
    write: function write(value, bytes, offset) {
      var variableByteArray = encoder.encode(value);
      var fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
      bytes.set(fixedByteArray, offset);
      return offset + fixedBytes;
    }
  });
}

function fixDecoder(decoder, fixedBytes) {
  return createDecoder({
    fixedSize: fixedBytes,
    read: function read(bytes, offset) {
      assertByteArrayHasEnoughBytesForCodec("fixCodec", fixedBytes, bytes, offset);

      if (offset > 0 || bytes.length > fixedBytes) {
        bytes = bytes.slice(offset, offset + fixedBytes);
      }

      if (isFixedSize(decoder)) {
        bytes = fixBytes(bytes, decoder.fixedSize);
      }

      var _decoder$read = decoder.read(bytes, 0),
          _decoder$read2 = _slicedToArray(_decoder$read, 1),
          value = _decoder$read2[0];

      return [value, offset + fixedBytes];
    }
  });
}

function fixCodec(codec, fixedBytes) {
  return combineCodec(fixEncoder(codec, fixedBytes), fixDecoder(codec, fixedBytes));
} // src/map-codec.ts


function mapEncoder(encoder, unmap) {
  return createEncoder(_objectSpread(_objectSpread({}, isVariableSize(encoder) ? _objectSpread(_objectSpread({}, encoder), {}, {
    getSizeFromValue: function getSizeFromValue(value) {
      return encoder.getSizeFromValue(unmap(value));
    }
  }) : encoder), {}, {
    write: function write(value, bytes, offset) {
      return encoder.write(unmap(value), bytes, offset);
    }
  }));
}

function mapDecoder(decoder, map) {
  return createDecoder(_objectSpread(_objectSpread({}, decoder), {}, {
    read: function read(bytes, offset) {
      var _decoder$read3 = decoder.read(bytes, offset),
          _decoder$read4 = _slicedToArray(_decoder$read3, 2),
          value = _decoder$read4[0],
          newOffset = _decoder$read4[1];

      return [map(value, bytes, offset), newOffset];
    }
  }));
}

function mapCodec(codec, unmap, map) {
  return createCodec(_objectSpread(_objectSpread({}, mapEncoder(codec, unmap)), {}, {
    read: map ? mapDecoder(codec, map).read : codec.read
  }));
} // src/offset-codec.ts


function offsetEncoder(encoder, config) {
  return createEncoder(_objectSpread(_objectSpread({}, encoder), {}, {
    write: function write(value, bytes, preOffset) {
      var wrapBytes = function wrapBytes(offset) {
        return modulo(offset, bytes.length);
      };

      var newPreOffset = config.preOffset ? config.preOffset({
        bytes: bytes,
        preOffset: preOffset,
        wrapBytes: wrapBytes
      }) : preOffset;
      assertByteArrayOffsetIsNotOutOfRange("offsetEncoder", newPreOffset, bytes.length);
      var postOffset = encoder.write(value, bytes, newPreOffset);
      var newPostOffset = config.postOffset ? config.postOffset({
        bytes: bytes,
        newPreOffset: newPreOffset,
        postOffset: postOffset,
        preOffset: preOffset,
        wrapBytes: wrapBytes
      }) : postOffset;
      assertByteArrayOffsetIsNotOutOfRange("offsetEncoder", newPostOffset, bytes.length);
      return newPostOffset;
    }
  }));
}

function offsetDecoder(decoder, config) {
  return createDecoder(_objectSpread(_objectSpread({}, decoder), {}, {
    read: function read(bytes, preOffset) {
      var wrapBytes = function wrapBytes(offset) {
        return modulo(offset, bytes.length);
      };

      var newPreOffset = config.preOffset ? config.preOffset({
        bytes: bytes,
        preOffset: preOffset,
        wrapBytes: wrapBytes
      }) : preOffset;
      assertByteArrayOffsetIsNotOutOfRange("offsetDecoder", newPreOffset, bytes.length);

      var _decoder$read5 = decoder.read(bytes, newPreOffset),
          _decoder$read6 = _slicedToArray(_decoder$read5, 2),
          value = _decoder$read6[0],
          postOffset = _decoder$read6[1];

      var newPostOffset = config.postOffset ? config.postOffset({
        bytes: bytes,
        newPreOffset: newPreOffset,
        postOffset: postOffset,
        preOffset: preOffset,
        wrapBytes: wrapBytes
      }) : postOffset;
      assertByteArrayOffsetIsNotOutOfRange("offsetDecoder", newPostOffset, bytes.length);
      return [value, newPostOffset];
    }
  }));
}

function offsetCodec(codec, config) {
  return combineCodec(offsetEncoder(codec, config), offsetDecoder(codec, config));
}

function modulo(dividend, divisor) {
  if (divisor === 0) return 0;
  return (dividend % divisor + divisor) % divisor;
}

function resizeEncoder(encoder, resize) {
  if (isFixedSize(encoder)) {
    var fixedSize = resize(encoder.fixedSize);

    if (fixedSize < 0) {
      throw new SolanaError(SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH, {
        bytesLength: fixedSize,
        codecDescription: "resizeEncoder"
      });
    }

    return createEncoder(_objectSpread(_objectSpread({}, encoder), {}, {
      fixedSize: fixedSize
    }));
  }

  return createEncoder(_objectSpread(_objectSpread({}, encoder), {}, {
    getSizeFromValue: function getSizeFromValue(value) {
      var newSize = resize(encoder.getSizeFromValue(value));

      if (newSize < 0) {
        throw new SolanaError(SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH, {
          bytesLength: newSize,
          codecDescription: "resizeEncoder"
        });
      }

      return newSize;
    }
  }));
}

function resizeDecoder(decoder, resize) {
  if (isFixedSize(decoder)) {
    var fixedSize = resize(decoder.fixedSize);

    if (fixedSize < 0) {
      throw new SolanaError(SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH, {
        bytesLength: fixedSize,
        codecDescription: "resizeDecoder"
      });
    }

    return createDecoder(_objectSpread(_objectSpread({}, decoder), {}, {
      fixedSize: fixedSize
    }));
  }

  return decoder;
}

function resizeCodec(codec, resize) {
  return combineCodec(resizeEncoder(codec, resize), resizeDecoder(codec, resize));
} // src/pad-codec.ts


function padLeftEncoder(encoder, offset) {
  return offsetEncoder(resizeEncoder(encoder, function (size) {
    return size + offset;
  }), {
    preOffset: function preOffset(_ref) {
      var _preOffset = _ref.preOffset;
      return _preOffset + offset;
    }
  });
}

function padRightEncoder(encoder, offset) {
  return offsetEncoder(resizeEncoder(encoder, function (size) {
    return size + offset;
  }), {
    postOffset: function postOffset(_ref2) {
      var _postOffset = _ref2.postOffset;
      return _postOffset + offset;
    }
  });
}

function padLeftDecoder(decoder, offset) {
  return offsetDecoder(resizeDecoder(decoder, function (size) {
    return size + offset;
  }), {
    preOffset: function preOffset(_ref3) {
      var _preOffset2 = _ref3.preOffset;
      return _preOffset2 + offset;
    }
  });
}

function padRightDecoder(decoder, offset) {
  return offsetDecoder(resizeDecoder(decoder, function (size) {
    return size + offset;
  }), {
    postOffset: function postOffset(_ref4) {
      var _postOffset2 = _ref4.postOffset;
      return _postOffset2 + offset;
    }
  });
}

function padLeftCodec(codec, offset) {
  return combineCodec(padLeftEncoder(codec, offset), padLeftDecoder(codec, offset));
}

function padRightCodec(codec, offset) {
  return combineCodec(padRightEncoder(codec, offset), padRightDecoder(codec, offset));
} // src/reverse-codec.ts


function reverseEncoder(encoder) {
  assertIsFixedSize(encoder);
  return createEncoder(_objectSpread(_objectSpread({}, encoder), {}, {
    write: function write(value, bytes, offset) {
      var newOffset = encoder.write(value, bytes, offset);
      var slice = bytes.slice(offset, offset + encoder.fixedSize).reverse();
      bytes.set(slice, offset);
      return newOffset;
    }
  }));
}

function reverseDecoder(decoder) {
  assertIsFixedSize(decoder);
  return createDecoder(_objectSpread(_objectSpread({}, decoder), {}, {
    read: function read(bytes, offset) {
      var reverseEnd = offset + decoder.fixedSize;

      if (offset === 0 && bytes.length === reverseEnd) {
        return decoder.read(bytes.reverse(), offset);
      }

      var reversedBytes = bytes.slice();
      reversedBytes.set(bytes.slice(offset, reverseEnd).reverse(), offset);
      return decoder.read(reversedBytes, offset);
    }
  }));
}

function reverseCodec(codec) {
  return combineCodec(reverseEncoder(codec), reverseDecoder(codec));
}

export { assertByteArrayHasEnoughBytesForCodec, assertByteArrayIsNotEmptyForCodec, assertByteArrayOffsetIsNotOutOfRange, assertIsFixedSize, assertIsVariableSize, combineCodec, createCodec, createDecoder, createEncoder, fixBytes, fixCodec, fixDecoder, fixEncoder, getEncodedSize, isFixedSize, isVariableSize, mapCodec, mapDecoder, mapEncoder, mergeBytes, offsetCodec, offsetDecoder, offsetEncoder, padBytes, padLeftCodec, padLeftDecoder, padLeftEncoder, padRightCodec, padRightDecoder, padRightEncoder, resizeCodec, resizeDecoder, resizeEncoder, reverseCodec, reverseDecoder, reverseEncoder };